export const sanitizePhoneNumber = (value) => {
    return value && value.replace(/\D/g, '');
};
export const sanitizeNumber = (value) => {
    return value && Number(value.toString().replace(/,/g, ''))
};

export const sanitizeFranchiseData = (value) => {
    if (value) {
        value.primaryPhone = (value.primaryPhone) && sanitizePhoneNumber(value.primaryPhone);
        value.alternatePhone = (value.alternatePhone) && sanitizePhoneNumber(value.alternatePhone);
        value.brokerOfRecordPhone = (value.brokerOfRecordPhone) && sanitizePhoneNumber(value.brokerOfRecordPhone);
        
        if (value.ein === '') { value.ein = null; }
        if (Array.isArray(value.owners)) {
            value.owners = value.owners.map((owner) => ({
                ...owner,
                phone: owner.phone ? sanitizePhoneNumber(owner.phone) : owner.phone
            }));
        }
    }

    return value;
};